import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

function PieChart({ data }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  // create chart on mount
  useEffect(() => {
    Chart.defaults.font.size = 15;
    const chart = new Chart(canvasRef.current, {
      type: "doughnut",
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 2.6,
        plugins: {
          legend: {
            position: "left",
            labels: {
              padding: 10,
            },
            onHover: function (e) {
              const target = e?.native?.target;
              if (target && target.style) target.style.cursor = "pointer";
            },
            onLeave: function (e) {
              const target = e?.native?.target;
              if (target && target.style) target.style.cursor = "default";
            },
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const dataset = context.dataset;
                const currentValue = context.parsed;
                const total = Array.isArray(dataset.data)
                  ? dataset.data.reduce(
                      (sum, v) =>
                        sum + (typeof v === "number" ? v : Number(v) || 0),
                      0
                    )
                  : 0;
                const percentage = total
                  ? parseFloat(((currentValue / total) * 100).toFixed(1))
                  : 0;
                return ` ${currentValue} findings (${percentage}%)`;
              },
              title: function (contexts) {
                return contexts && contexts.length ? contexts[0].label : "";
              },
            },
          },
        },
        layout: { padding: 0 },
      },
      // initialize empty and let the data effect populate to avoid hook deps warning
      data: { labels: [], datasets: [] },
    });
    chartRef.current = chart;
    return () => chart.destroy();
  }, []);

  // update data
  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    chart.data = data;
    chart.update();
  }, [data]);

  return <canvas ref={canvasRef} height='250px' />;
}

export default PieChart;
